import type { SourceGroup } from "../lib/types";

/**
 * The demo's visible proof that a current-affairs answer was retrieved rather
 * than invented. Worth the screen space for exactly that reason.
 */
export function SourceCards({ groups }: { groups: SourceGroup[] }) {
  if (groups.length === 0) return null;

  return (
    <section className="panel sources" aria-label="Sources used">
      <h2 className="panel__title">Sources</h2>
      {groups.map((group) => (
        <div key={group.id} className="sources__group">
          <p className="sources__query">Searched “{group.query}”</p>
          <ul className="sources__list">
            {group.sources.map((source) => (
              <li key={source.url} className="source">
                <a
                  className="source__title"
                  href={source.url}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  {source.title || source.url}
                </a>
                <span className="source__meta">
                  {source.publication}
                  {source.publication && source.published_at ? " · " : ""}
                  {source.published_at}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  );
}
